export default "__VITE_ASSET__Cb8YjIjT__"